import React from 'react';
import { AmountPicker, IllustrationRounded } from '@wegroup/design-system';
import { handleResponseLanguage } from '../../../../../i18n';
import { FlowsQuestion } from '../../../../flows/src/types/FlowsTypes';
import useFlowInputComponent from '../../../../flows/src/hooks/useFlowsInputComponent';

interface Props {
  question: FlowsQuestion;
}

const AmountInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onBlur },
  } = useFlowInputComponent({ question, defaultValue: 0 });

  const inputValue = value as number;
  const minValue = 0;
  const maxValue = 200;

  const handleInputChange = (val: React.ReactText, blur?: boolean) => {
    if ((val <= maxValue && val >= minValue) || val === '') {
      onBlur({ name: question.id, value: val });
    }
  };

  return (
    <AmountPicker
      min={minValue}
      max={maxValue}
      name={question?.id}
      illustration={
        <IllustrationRounded
          type={question?.icon_key}
          isActive={inputValue > 0}
        />
      }
      value={inputValue}
      onChange={(_, val) => handleInputChange(val)}
      dataTestId={`RISK-ANALYSIS_AMOUNTINPUT_${question.id
        .toUpperCase()
        .replaceAll('.', '-')}`}
    >
      {handleResponseLanguage(question?.title)}
    </AmountPicker>
  );
};

export default AmountInputComponent;
